import actionTypes from '../constants/action-types';

const createMediaGalleryAssetsFromExternalSources = (assets, constraints, resolve, reject) => ({
  type: actionTypes.CREATE_MEDIA_GALLERY_ASSETS_FROM_EXTERNAL_SOURCES,
  payload: {
    assets,
    constraints,
    resolve,
    reject,
  },
});

export default createMediaGalleryAssetsFromExternalSources;
